import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DirectionsService {
  constructor() {
    // do nothing
  }

  getDirectionsUrl(addressLine1: string, city: string, state: string, zip: string): string {
    // note: no starting address is provided in the URL; the user must enable browser location on the Google Maps page
    return `https://www.google.com/maps/dir//${addressLine1}, ${city}, ${state} ${zip}`;
  }
}
